import { render, staticRenderFns } from "./user-grade-criteria.vue?vue&type=template&id=a7522d34&"
import script from "./user-grade-criteria.vue?vue&type=script&lang=js&"
export * from "./user-grade-criteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports